module.exports = __webpack_public_path__ + "fonts/roboto-mediumitalic-webfont.woff2";